import type { ResolvedComponent } from '@inertiajs/react';

type PageModule = {
  default: ResolvedComponent;
};

type PageLoader = () => Promise<PageModule>;
type PageComponentMap = Record<string, PageLoader>;

const loadShowPage = () => import('@Pages/pages/ShowPage');

export const pageComponents = {
  'pages::ShowPage': loadShowPage,
  'pages::ShowCodePage': loadShowPage
} satisfies PageComponentMap;

export function createPageComponentResolver(pages: PageComponentMap = pageComponents) {
  return async (pageName: string): Promise<ResolvedComponent> => {
    const loadPage = pages[pageName];

    if (!loadPage) {
      throw new Error(`Page bundle cannot resolve Inertia component [${pageName}].`);
    }

    return (await loadPage()).default;
  };
}

export const resolvePageComponent = createPageComponentResolver();
